import axios from "@/utils/axios";
import { asArray } from "@/utils/apiResponse";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getEmployeesData = async () => {
  const response = await axios.get(`${API_URL}/users`);
  return asArray(response.data);
};

export const createEmployee = async (data) => {
  const payload = toEmployeeFormData(data);
  const response = await axios.post(`${API_URL}/users`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.data;
};

export const checkEmployeeEmail = async (email, ignoreId = null) => {
  const response = await axios.get(`${API_URL}/users/email/check`, {
    params: {
      email,
      ignore_id: ignoreId ?? undefined,
    },
  });
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await axios.delete(`${API_URL}/users/${id}`);
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const payload = toEmployeeFormData(data);
  payload.append("_method", "PUT");
  const response = await axios.post(`${API_URL}/users/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.data;
};

const toEmployeeFormData = (data) => {
  const payload = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      payload.append(key, value);
    }
  });
  return payload;
};
